// extracted by mini-css-extract-plugin
export var active = "_cc-2";
export var recordingDot = "_cc-1";
export var recordingIndicator = "_cc-0";